import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./CourseList.css";
import { API_BASE_URL } from "../config";
import BookCourseCard from "./BookCourseCard.jsx";

function Certificate() {
  const navigate = useNavigate();
  const [certificates, setCertificates] = useState([]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/certificates`)
      .then((res) => res.json())
      .then((data) => setCertificates(data))
      .catch((err) =>
        console.error("Error fetching certificates:", err)
      );
  }, []);

  /* ✅ Learning Environment data (certificate-specific) */
  const highlights = [
    {
      id: 1,
      src: "/greenery_acre.webp",
      title: "Green Campus",
      desc: "24 Acre Greenish Campus",
    },
    {
      id: 2,
      src: "/hostel.webp",
      title: "Comfortable Stay",
      desc: "AC Hostel Facilities",
    },
    {
      id: 3,
      src: "/supportive_staff.webp",
      title: "Supportive Staff",
      desc: "Friendly & Professional Team",
    },
    {
      id: 4,
      src: "/carrier_support.webp",
      title: "Career Support",
      desc: "100% Placement Assistance",
    },
    {
      id: 5,
      src: "/community_hub.webp",
      title: "Community Hub",
      desc: "Strong Alumni & Community Support",
    },
  ];

  return (
    <div>
      {/* ================= CERTIFICATE CARDS ================= */}
      <div className="courses-container">
        {certificates.map((course) => (
          <BookCourseCard
            key={course._id}
            course={{
              name: course.name,
              days: course.days,
              price: course.price,
              gst: course.gst,
              description: course.description,
              image: course.image
                ? `${API_BASE_URL}${course.image}`
                : "/small_rpc.jpg",
            }}
            onApply={() =>
              navigate(`/certificate-enroll-template/${course._id}`)
            }
          />
        ))}
      </div>

      {/* ================= LEARNING ENVIRONMENT ================= */}
      <h1 className="circle-heading">Learning Environment</h1>

      <div className="circle-container">
        {highlights.map((item) => (
          <div className="circle-card" key={item.id}>
            <img src={item.src} alt={item.title} />
            <h3>{item.title}</h3>
            <p>{item.desc}</p>
          </div>
        ))}
      </div>

      <br />
      <br />
    </div>
  );
}

export default Certificate;
